import React from "react";
import PropertyCard from "./PropertyCard.tsx";
import { Link } from "react-router-dom";

const FeaturedProperties: React.FC = () => {
  const properties = [
    {
      id: 1,
      title: "Chola Greens",
      price: "$750,000",
      location: "Thanjavur , TN",
      area: "1800 sq ft",
      image: "./chola-greens.jpeg",
      dtcpStatus: "Approved" as "Approved",
      reraStatus: "Registered" as "Registered",
      detailsAvailable: true, // Enable button for Chola Greens
    },
    {
      id: 2,
      title: "Chola Flames",
      price: "$750,000",
      location: "Thanjavur , TN",
      area: "2,500 sq ft",
      image: "./chola-flames.png",
      detailsAvailable: false, // Disable button for Chola Flames
    },
    {
      id: 3,
      title: "Chola Rail Gardens",
      price: "$1,200,000",
      location: "Thanjavur , TN",
      area: "1,800 sq ft",
      image: "./chola-rail-gardens.png",
      detailsAvailable: false, // Disable button for Chola Rail Gardens
    },
    {
      id: 4,
      title: "Chola Meadows",
      price: "$450,000",
      location: "Thanjavur , TN",
      area: "1,900 sq ft",
      image: "./chola-meadows.png",
      detailsAvailable: false, // Disable button for Chola Meadows
    },
  ];
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Featured Properties
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Discover our handpicked selection of premium properties
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {properties.map((property) => (
            <PropertyCard key={property.id} property={property} />
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/properties" className="btn-primary">
            View All Properties
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProperties;
